// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-less-array__item_c2f037a7 {
  white-space: normal;
  line-height: 1.715;
}
.more-less-array__item_d-block_c2f037a7 {
  display: block;
}
.more-less-array__item_inline_c2f037a7 {
  display: inline;
}
.more-less-array__item_inline-block_c2f037a7 {
  display: inline-block;
}
.more-less-array_d-block_c2f037a7 {
  display: block;
}
.more-less-array_inline_c2f037a7 {
  display: inline;
}
.more-less-array_inline-block_c2f037a7 {
  display: inline-block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"more-less-array__item": `more-less-array__item_c2f037a7`,
	"more-less-array__item_d-block": `more-less-array__item_d-block_c2f037a7`,
	"more-less-array__item_inline": `more-less-array__item_inline_c2f037a7`,
	"more-less-array__item_inline-block": `more-less-array__item_inline-block_c2f037a7`,
	"more-less-array_d-block": `more-less-array_d-block_c2f037a7`,
	"more-less-array_inline": `more-less-array_inline_c2f037a7`,
	"more-less-array_inline-block": `more-less-array_inline-block_c2f037a7`
};
export default ___CSS_LOADER_EXPORT___;
